
import { Component, Vue, Prop } from "vue-property-decorator"
import { Getter, State, Action } from "vuex-class"

import { TimeZone } from "@/types"

@Component
export default class TimeZoneSelect extends Vue {
	@State screenWidth!: number
	@State displayTimezone!: TimeZone | null
	@Getter("getTenantTimezones") timezones!: TimeZone[]

	@Action setDisplayTimezone!: (timezone: TimeZone | null) => void

	@Prop({ default: false })
	hideTimezoneTitle!: boolean

	selectTimezone (timezone: TimeZone | null) {
		this.setDisplayTimezone(timezone)
	}

	formattedTimezoneTitle (timezone: TimeZone) {
		if (!timezone.nonAliasedTitle || timezone.nonAliasedTitle === timezone.title) {
			return timezone.title
		}
		return `${timezone.title} - ${timezone.nonAliasedTitle}`
	}
}
